// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Encabezado } from '../../Components/Encabezado/Encabezado';
// import { getPhoto } from '../../utils/getPhoto';
// import { Image } from '../../Components/Profile/Image';

// import {
//   Box,
//   Divider,
//   Grid,
//   Paper,
//   Stack,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow
// } from '@mui/material';

// import Typography from "@mui/material/Typography";
// import GroupsIcon from '@mui/icons-material/Groups';
// import ManIcon from '@mui/icons-material/Man';
// import WomanIcon from '@mui/icons-material/Woman';

// import {
//   fetchEmpleadoCumpleanos,
//   fetchPanelControl,
//   selectEmpleadoCumpleanos,
//   selectPanelControl
// } from "../../redux/Empleados/EmpleadosSlice";


// export const PanelControl = () => {

//   // ? HOOK-DISPATCH
//   const dispatch = useDispatch();

//   // ? HOOK-SELECTOR
//   const cumpleanos = useSelector(selectEmpleadoCumpleanos);
//   const panelControl = useSelector(selectPanelControl);

//   const arrTotales = [
//     {
//       Icon: GroupsIcon,
//       titulo: 'Cantidad de Empleados',
//       cantidad: panelControl.cantidadEmpleados ?? 0
//     },
//     {
//       Icon: ManIcon,
//       titulo: 'Cantidad de Hombres',
//       cantidad: panelControl.cantidadHombres ?? 0
//     },
//     {
//       Icon: WomanIcon,
//       titulo: 'Cantidad de Mujeres',
//       cantidad: panelControl.cantidadMujeres ?? 0
//     }
//   ];

//   useEffect(() => {
//     dispatch(fetchEmpleadoCumpleanos())
//     dispatch(fetchPanelControl())
//   }, [])

//   return (

//     <Encabezado title='Panel de Control'>

//       <Grid container spacing={2}>

//         {
//           arrTotales.map((item, index) => (
//             <Grid item xs={4} key={index}>
//               <Paper sx={{ backgroundColor: '#003876' }}>

//                 <Grid container>

//                   <Grid item xs={4}>
//                     <Box padding={3}>
//                       <item.Icon style={{ fontSize: '7vw' }} sx={{ color: 'white' }} />
//                     </Box>
//                   </Grid>

//                   <Grid item xs={8} display='flex' justifyContent='end'>
//                     <Box padding={3} pt={4}>
//                       <Typography sx={{ color: 'white', fontSize: '1.6vw' }} align='right'>{item.cantidad}</Typography>
//                       <Typography sx={{ color: 'white', fontSize: '1.2vw' }} variant='h6'>{item.titulo}</Typography>
//                     </Box>
//                   </Grid>

//                 </Grid>

//               </Paper>
//             </Grid>
//           ))
//         }

//       </Grid>

//       <Grid container mt={2} spacing={2}>

//         <Grid item xs={3}>
//           <Paper>

//             <Stack p={2}>
//               <Typography textTransform='uppercase'>Empleados según estado civil</Typography>
//               <Divider />

//               <Box mt={2}>
//                 <TableContainer component={Paper}>
//                   <Table sx={{ minWidth: { lg: 200, md: 100, sm: 50 } }} aria-label="simple table">

//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 'bold' }}>Estado Civil</TableCell>
//                         <TableCell sx={{ fontWeight: 'bold' }}>Cantidad</TableCell>
//                       </TableRow>
//                     </TableHead>

//                     <TableBody>

//                       {
//                         panelControl?.listaEstadosCiviles?.map((item, index) => (

//                           <TableRow key={index}>
//                             <TableCell>{item.nombre}</TableCell>
//                             <TableCell>{item.cantidad}</TableCell>
//                           </TableRow>

//                         ))
//                       }


//                     </TableBody>
//                   </Table>

//                 </TableContainer>
//               </Box>

//             </Stack>
//           </Paper>
//         </Grid>

//         <Grid item xs={3}>
//           <Paper>

//             <Stack p={2}>
//               <Typography textTransform='uppercase'>Empleados según tipo</Typography>
//               <Divider />

//               <Box mt={2}>

//                 <TableContainer component={Paper}>
//                   <Table sx={{ minWidth: { lg: 200, md: 100, sm: 50 } }} aria-label="simple table">

//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 'bold' }}>Tipo</TableCell>
//                         <TableCell sx={{ fontWeight: 'bold' }}>Cantidad</TableCell>
//                       </TableRow>
//                     </TableHead>

//                     <TableBody>
//                       {
//                         panelControl?.listaTipoEmpleado?.map((item, index) => (

//                           <TableRow key={index}>
//                             <TableCell>{item.nombre}</TableCell>
//                             <TableCell>{item.cantidad}</TableCell>
//                           </TableRow>

//                         ))
//                       }
//                     </TableBody>
//                   </Table>

//                 </TableContainer>

//               </Box>
//             </Stack>

//           </Paper>
//         </Grid>

//         <Grid item xs={3}>
//           <Paper>

//             <Stack p={2}>
//               <Typography textTransform='uppercase'>Empleados Por Dependencia</Typography>
//               <Divider />

//               <Box mt={2}>

//                 <TableContainer component={Paper}>
//                   <Table sx={{ minWidth: { lg: 200, md: 100, sm: 50 } }} aria-label="simple table">

//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 'bold' }}>Tipo</TableCell>
//                         <TableCell sx={{ fontWeight: 'bold' }}>Cantidad</TableCell>
//                       </TableRow>
//                     </TableHead>

//                     <TableBody>
//                       {
//                         panelControl?.listaEmpleadosUbicacion?.map((item, index) => (

//                           <TableRow key={item.id}>
//                             <TableCell>{item.nombre}</TableCell>
//                             <TableCell>{item.cantidad}</TableCell>
//                           </TableRow>

//                         ))
//                       }
//                     </TableBody>
//                   </Table>

//                 </TableContainer>

//               </Box>
//             </Stack>

//           </Paper>
//         </Grid>

//         <Grid item xs={3}>
//           <Paper>

//             <Stack p={2} component='div'>
//               <Typography textTransform='uppercase'>Cumpleaños de hoy</Typography>
//               <Divider />

//               <Box mt={2}>
//                 {
//                   cumpleanos.map((item, index) => (

//                     <Paper elevation={3} key={index}>
//                       <Grid container mb={1}>
//                         <Grid item md={5} lg={4} xs={4} padding={1} mb={-3}>
//                           <Image src={getPhoto(item)} sx={{ height: '80%', borderRadius: 2 }} />
//                         </Grid>

//                         <Grid item md={7} lg={8} xs={8} padding={2}>
//                           <Typography fontWeight='bold' fontSize={{ lg: 14, md: 13, sm: 14 }} >{item.nombreCompleto}</Typography>
//                           <Typography fontSize={{ lg: 13, md: 12, sm: 12 }}>{item.departamento}</Typography>
//                         </Grid>
//                       </Grid>
//                     </Paper>

//                   ))
//                 }
//               </Box>

//             </Stack>

//           </Paper>
//         </Grid>

//       </Grid>

//     </Encabezado>
//   )
// }

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Encabezado } from '../../Components/Encabezado/Encabezado';
import { getPhoto } from '../../utils/getPhoto';
import { Image } from '../../Components/Profile/Image';

import {
  Avatar,
  Box,
  Grid,
  Paper,
  Stack,
  Typography
} from '@mui/material';

import GroupsIcon from '@mui/icons-material/Groups';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ApartmentIcon from '@mui/icons-material/Apartment';
import CakeIcon from '@mui/icons-material/Cake';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

import {
  fetchEmpleadoCumpleanos,
  fetchPanelControl,
  selectEmpleadoCumpleanos,
  selectPanelControl
} from '../../redux/Empleados/EmpleadosSlice';


/* =========================================================
   COLORES
========================================================= */

const COLOR_PRINCIPAL = '#003876';
const COLOR_SECUNDARIO = '#0B67C2';
const COLOR_FONDO = '#F4F7FB';
const COLOR_BARRA_FONDO = '#E7EEF6';


/* =========================================================
   COMPONENTE PRINCIPAL
========================================================= */

export const PanelControl = () => {

  const dispatch = useDispatch();

  const cumpleanos = useSelector(selectEmpleadoCumpleanos);
  const panelControl = useSelector(selectPanelControl);

  useEffect(() => {
    dispatch(fetchEmpleadoCumpleanos());
    dispatch(fetchPanelControl());
  }, [dispatch]);


  /* =========================================================
     TOTALES
  ========================================================= */

  const totalEmpleados = panelControl?.cantidadEmpleados ?? 0;
  const cantidadHombres = panelControl?.cantidadHombres ?? 0;
  const cantidadMujeres = panelControl?.cantidadMujeres ?? 0;

  const porcentajeHombres =
    totalEmpleados > 0
      ? ((cantidadHombres / totalEmpleados) * 100).toFixed(1)
      : 0;

  const porcentajeMujeres =
    totalEmpleados > 0
      ? ((cantidadMujeres / totalEmpleados) * 100).toFixed(1)
      : 0;


  const arrTotales = [
    {
      Icon: GroupsIcon,
      titulo: 'Cantidad de Empleados',
      cantidad: totalEmpleados,
      detalle: 'Nuestro mayor activo',
      ExtraIcon: TrendingUpIcon
    },
    {
      Icon: ManIcon,
      titulo: 'Cantidad de Hombres',
      cantidad: cantidadHombres,
      detalle: `${porcentajeHombres}% del total`
    },
    {
      Icon: WomanIcon,
      titulo: 'Cantidad de Mujeres',
      cantidad: cantidadMujeres,
      detalle: `${porcentajeMujeres}% del total`
    }
  ];


  return (

    <Encabezado title='Panel de Control'>

      <Box
        sx={{
          backgroundColor: COLOR_FONDO,
          minHeight: '100vh',
          p: {
            xs: 1,
            md: 1.5
          }
        }}
      >

        {/* =====================================================
            TARJETAS SUPERIORES
        ====================================================== */}

        <Grid container spacing={1.5}>

          {arrTotales.map((item, index) => (

            <Grid
              item
              xs={12}
              md={4}
              key={index}
            >

              <Paper
                elevation={0}
                sx={{
                  minHeight: 115,
                  borderRadius: 2.5,
                  px: 2,
                  py: 1.5,
                  position: 'relative',
                  overflow: 'hidden',

                  border: '1px solid #DFE7F0',

                  boxShadow:
                    '0 4px 14px rgba(0, 56, 118, 0.07)',

                  background:
                    'linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 62%, #F2F8FD 100%)'
                }}
              >

                {/* Decoración de fondo */}

                <Box
                  sx={{
                    position: 'absolute',
                    width: 180,
                    height: 95,
                    borderRadius: '50%',
                    backgroundColor: '#EEF6FC',
                    right: -45,
                    bottom: -38
                  }}
                />


                <Stack
                  direction='row'
                  alignItems='center'
                  spacing={2}
                  sx={{
                    height: '100%',
                    position: 'relative',
                    zIndex: 1
                  }}
                >

                  {/* Icono */}

                  <Avatar
                    sx={{
                      width: 72,
                      height: 72,

                      backgroundColor: '#DDF0FF',
                      color: COLOR_SECUNDARIO
                    }}
                  >
                    <item.Icon sx={{ fontSize: 42 }} />
                  </Avatar>


                  {/* Información */}

                  <Box flex={1}>

                    <Typography
                      sx={{
                        color: COLOR_PRINCIPAL,
                        fontWeight: 700,
                        fontSize: 17
                      }}
                    >
                      {item.titulo}
                    </Typography>

                    <Typography
                      sx={{
                        color: COLOR_PRINCIPAL,
                        fontWeight: 800,

                        lineHeight: 1,

                        fontSize: {
                          xs: 38,
                          lg: 42
                        }
                      }}
                    >
                      {item.cantidad}
                    </Typography>

                  </Box>


                  {/* Información secundaria */}

                  <Stack
                    alignItems='flex-end'
                    justifyContent='center'
                    spacing={0.5}
                  >

                    {item.ExtraIcon && (

                      <Avatar
                        sx={{
                          width: 28,
                          height: 28,

                          bgcolor: '#CFF4DE',
                          color: '#20A464'
                        }}
                      >
                        <item.ExtraIcon
                          sx={{
                            fontSize: 17
                          }}
                        />
                      </Avatar>

                    )}

                    <Typography
                      sx={{
                        fontSize: 13,
                        color: '#57779A',

                        textAlign: 'right',

                        whiteSpace: {
                          md: 'normal',
                          lg: 'nowrap'
                        }
                      }}
                    >
                      {item.detalle}
                    </Typography>

                  </Stack>

                </Stack>

              </Paper>

            </Grid>

          ))}

        </Grid>


        {/* =====================================================
            GRÁFICOS
        ====================================================== */}

        <Grid
          container
          spacing={1.5}
          mt={0}
        >

          <Grid
            item
            xs={12}
            lg={4}
          >

            <DashboardChartCard
              icon={DonutLargeIcon}
              title='Empleados según estado civil'
              subtitle='Distribución del personal por estado civil'
              data={panelControl?.listaEstadosCiviles ?? []}
            />

          </Grid>


          <Grid
            item
            xs={12}
            lg={4}
          >

            <DashboardChartCard
              icon={BusinessCenterIcon}
              title='Empleados según tipo'
              subtitle='Distribución del personal por tipo de vinculación'
              data={panelControl?.listaTipoEmpleado ?? []}
            />

          </Grid>


          <Grid
            item
            xs={12}
            lg={4}
          >

            <DashboardChartCard
              icon={ApartmentIcon}
              title='Empleados por dependencia'
              subtitle='Cantidad de empleados en cada dependencia'
              data={panelControl?.listaEmpleadosUbicacion ?? []}
            />

          </Grid>

        </Grid>


        {/* =====================================================
            CUMPLEAÑOS
        ====================================================== */}

        <Paper
          elevation={0}
          sx={{
            mt: 1.5,
            p: 2,

            borderRadius: 2.5,

            border: '1px solid #DFE7F0',

            boxShadow:
              '0 4px 14px rgba(0, 56, 118, 0.06)'
          }}
        >

          {/* HEADER CUMPLEAÑOS */}

          <Stack
            direction={{
              xs: 'column',
              sm: 'row'
            }}
            justifyContent='space-between'
            alignItems={{
              xs: 'flex-start',
              sm: 'center'
            }}
            spacing={1}
            mb={1.5}
          >

            <Stack
              direction='row'
              spacing={1.5}
              alignItems='center'
            >

              <Avatar
                sx={{
                  bgcolor: '#DDF0FF',
                  color: COLOR_SECUNDARIO,

                  width: 44,
                  height: 44
                }}
              >
                <CakeIcon
                  sx={{
                    fontSize: 22
                  }}
                />
              </Avatar>


              <Box>

                <Typography
                  sx={{
                    fontWeight: 700,
                    color: COLOR_PRINCIPAL,
                    fontSize: 17
                  }}
                >
                  Cumpleaños de hoy
                </Typography>

                <Typography
                  sx={{
                    color: '#6682A0',
                    fontSize: 12.5
                  }}
                >
                  Colaboradores que celebran su cumpleaños en esta fecha
                </Typography>

              </Box>

            </Stack>


            {cumpleanos?.length > 0 && (

              <Box
                sx={{
                  px: 1.5,
                  py: 0.7,

                  borderRadius: 2,

                  border:
                    '1px solid #BFDDF5',

                  backgroundColor:
                    '#F1F8FE',

                  color:
                    COLOR_SECUNDARIO,

                  fontWeight: 600,
                  fontSize: 12.5
                }}
              >
                🎉 ¡Felicidades en su día!
              </Box>

            )}

          </Stack>


          {/* =====================================================
              LISTADO CUMPLEAÑOS
          ====================================================== */}

          {cumpleanos?.length > 0 ? (

            <Grid
              container
              spacing={1.25}
            >

              {cumpleanos.map((item, index) => (

                <Grid
                  item
                  xs={12}
                  md={6}
                  lg={4}
                  key={index}
                >

                  <Paper
                    elevation={0}
                    sx={{
                      px: 1.5,
                      py: 1.2,

                      borderRadius: 2,

                      border:
                        '1px solid #DFE7F0',

                      transition:
                        'all .2s ease',

                      '&:hover': {
                        transform:
                          'translateY(-1px)',

                        boxShadow:
                          '0 4px 12px rgba(0,56,118,.09)'
                      }
                    }}
                  >

                    <Stack
                      direction='row'
                      alignItems='center'
                      spacing={1.5}
                    >

                      {/* FOTO */}

                      <Box
                        sx={{
                          width: 54,
                          height: 54,

                          borderRadius: '50%',

                          overflow: 'hidden',

                          flexShrink: 0,

                          backgroundColor:
                            '#EEF3F8'
                        }}
                      >

                        <Image
                          src={getPhoto(item)}
                          sx={{
                            width: '100%',
                            height: '100%',

                            objectFit:
                              'cover'
                          }}
                        />

                      </Box>


                      {/* NOMBRE / DEPARTAMENTO */}

                      <Box
                        flex={1}
                        sx={{
                          minWidth: 0
                        }}
                      >

                        <Typography
                          noWrap
                          title={
                            item.nombreCompleto
                          }
                          sx={{
                            fontWeight: 700,
                            color:
                              COLOR_PRINCIPAL,

                            fontSize: 14
                          }}
                        >
                          {item.nombreCompleto}
                        </Typography>


                        <Typography
                          noWrap
                          title={
                            item.departamento
                          }
                          sx={{
                            color:
                              '#6682A0',

                            fontSize:
                              12.5
                          }}
                        >
                          {item.departamento}
                        </Typography>

                      </Box>


                      {/* ICONO */}

                      <Stack
                        direction='row'
                        alignItems='center'
                        spacing={0.6}
                        sx={{
                          display: {
                            xs: 'none',
                            sm: 'flex'
                          }
                        }}
                      >

                        <CakeIcon
                          sx={{
                            color:
                              COLOR_SECUNDARIO,

                            fontSize:
                              25
                          }}
                        />


                        <Box
                          sx={{
                            display: {
                              xs: 'none',
                              xl: 'block'
                            }
                          }}
                        >

                          <Typography
                            sx={{
                              color:
                                COLOR_PRINCIPAL,

                              fontWeight:
                                700,

                              fontSize:
                                11.5,

                              lineHeight:
                                1.1
                            }}
                          >
                            Hoy
                          </Typography>

                          <Typography
                            sx={{
                              color:
                                '#6682A0',

                              fontSize:
                                10.5,

                              whiteSpace:
                                'nowrap'
                            }}
                          >
                            es su cumpleaños
                          </Typography>

                        </Box>

                      </Stack>

                    </Stack>

                  </Paper>

                </Grid>

              ))}

            </Grid>

          ) : (

            /* =====================================================
               SIN CUMPLEAÑOS
            ====================================================== */

            <Box
              sx={{
                minHeight: 90,

                display: 'flex',

                flexDirection:
                  'column',

                justifyContent:
                  'center',

                alignItems:
                  'center',

                color:
                  '#8295A9'
              }}
            >

              <CakeIcon
                sx={{
                  fontSize: 34,
                  mb: 0.5
                }}
              />


              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 600
                }}
              >
                No hay cumpleaños registrados para hoy.
              </Typography>


              <Typography
                sx={{
                  fontSize: 12.5
                }}
              >
                ¡Vuelve pronto!
              </Typography>

            </Box>

          )}

        </Paper>

      </Box>

    </Encabezado>

  );

};



/* =========================================================
   COMPONENTE PARA LOS GRÁFICOS
========================================================= */

const DashboardChartCard = ({
  icon: Icon,
  title,
  subtitle,
  data = []
}) => {


  /* Mayor valor de la lista */

  const maxValue = Math.max(
    ...data.map(
      x => Number(x.cantidad) || 0
    ),
    1
  );


  return (

    <Paper
      elevation={0}
      sx={{
        height: '100%',

        p: 2,

        borderRadius: 2.5,

        border:
          '1px solid #DFE7F0',

        boxShadow:
          '0 4px 14px rgba(0, 56, 118, 0.06)'
      }}
    >

      {/* =====================================================
          HEADER
      ====================================================== */}

      <Stack
        direction='row'
        spacing={1.5}
        alignItems='center'
        mb={1.5}
      >

        <Avatar
          sx={{
            width: 44,
            height: 44,

            bgcolor:
              '#DDF0FF',

            color:
              COLOR_SECUNDARIO
          }}
        >

          <Icon
            sx={{
              fontSize: 23
            }}
          />

        </Avatar>


        <Box flex={1}>

          <Typography
            sx={{
              fontWeight: 700,

              color:
                COLOR_PRINCIPAL,

              fontSize: 17,

              lineHeight: 1.2
            }}
          >
            {title}
          </Typography>


          <Typography
            sx={{
              color:
                '#6682A0',

              fontSize:
                12.5,

              mt: 0.2
            }}
          >
            {subtitle}
          </Typography>

        </Box>

      </Stack>


      {/* =====================================================
          BARRAS
      ====================================================== */}

      <Stack spacing={1.25}>

        {data.map((item, index) => {


          const cantidad =
            Number(item.cantidad) || 0;


          const porcentaje =
            maxValue > 0
              ? (cantidad / maxValue) * 100
              : 0;


          return (

            <Grid
              container
              spacing={1}
              alignItems='center'
              key={
                item.id ??
                index
              }
            >

              {/* TEXTO */}

              <Grid
                item
                xs={4}
              >

                <Typography
                  title={item.nombre}
                  sx={{
                    color:
                      '#274B72',

                    fontSize:
                      12.5,

                    lineHeight:
                      1.1,

                    overflow:
                      'hidden',

                    textOverflow:
                      'ellipsis',

                    whiteSpace:
                      'nowrap'
                  }}
                >
                  {item.nombre}
                </Typography>

              </Grid>


              {/* BARRA */}

              <Grid
                item
                xs={6}
              >

                <Box
                  sx={{
                    width: '100%',

                    height: 14,

                    backgroundColor:
                      COLOR_BARRA_FONDO,

                    borderRadius:
                      1,

                    overflow:
                      'hidden'
                  }}
                >

                  <Box
                    sx={{
                      height:
                        '100%',

                      width:
                        cantidad === 0
                          ? '0%'
                          : `${Math.max(
                              porcentaje,
                              1.5
                            )}%`,

                      borderRadius:
                        1,

                      background:
                        'linear-gradient(90deg, #005BAF 0%, #1488E5 100%)',

                      transition:
                        'width .5s ease'
                    }}
                  />

                </Box>

              </Grid>


              {/* CANTIDAD */}

              <Grid
                item
                xs={2}
              >

                <Typography
                  sx={{
                    textAlign:
                      'right',

                    fontWeight:
                      600,

                    color:
                      COLOR_PRINCIPAL,

                    fontSize:
                      12.5
                  }}
                >
                  {cantidad}
                </Typography>

              </Grid>

            </Grid>

          );

        })}

      </Stack>

    </Paper>

  );

};